import React from 'react';
import { cn } from './cn';

// `asChild` renders the single child element (e.g. an <a download>) with the
// button's classes instead of a <button>, like shadcn's Slot.
const Button = React.forwardRef(function Button(
  { className, variant = 'default', size = 'default', type = 'button', asChild = false, children, ...props },
  ref,
) {
  const classes = cn('ui-btn', `ui-btn--${variant}`, `ui-btn--${size}`, className);
  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, {
      ...props,
      ref,
      className: cn(classes, children.props.className),
    });
  }
  return (
    <button ref={ref} type={type} className={classes} {...props}>
      {children}
    </button>
  );
});

export { Button };
